import { render, staticRenderFns } from "./AllInvestmentsReceivablesCollectionReportModal.vue?vue&type=template&id=03140b1a&"
import script from "./AllInvestmentsReceivablesCollectionReportModal.vue?vue&type=script&lang=js&"
export * from "./AllInvestmentsReceivablesCollectionReportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports